import React from 'react';
import './DealCardSkeleton.css';

const DealCardSkeleton: React.FC = () => {
  return (
    <div className="deal-card-skeleton-container">
      <div className="skeleton-image"></div>
      <div className="skeleton-content">
        <div className="skeleton-title"></div>
        <div className="skeleton-text-short"></div>
        <div className="skeleton-price"></div>
        <div className="skeleton-button"></div>
      </div>
    </div>
  );
};

export default DealCardSkeleton;
